<template>
  <div>
    <h2 class="page-title">Emitir GTIV Eletrônico</h2>
    <div class="form-steps-vue">
      <div class="steps">
        <div class="tabs">
          <h3 class="tab tab-0">Dados da origem</h3>
          <h3 class="tab tab-1">Produtos</h3>
          <h3 class="tab tab-2">Destino</h3>
          <h3 class="tab tab-3">Transporte/ Condutor</h3>
        </div>
        <div class="content">
          <div class="container content-0">
            <p class="text-description">
              No primeiro passo, vamos precisar que você confirme seus dados e
              informe os dados dos produtos. Após preencher as informações
              obrigatórias
              <span class="text text-red">(*)</span>, clique em
              <span class="text-next" @click="changeStep($event, +1)"
                >Próximo</span
              >.
            </p>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group required">
                  <label for="cpf_cnpj_produtor_origem"
                    >CPF/CNPJ do proprietário</label
                  >
                  <input
                    type="text"
                    class="form-control loading"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    name="cpf_cnpj_produtor_origem"
                    id="cpf_cnpj_produtor_origem"
                    v-model="dadosFicha.cpf_cnpj_produtor_origem"
                    disabled
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group required">
                  <label for="nome_produtor_origem">Nome do proprietário</label>
                  <input
                    type="text"
                    class="form-control"
                    name="nome_produtor_origem"
                    v-model="dadosFicha.nome_produtor_origem"
                    id="nome_produtor_origem"
                    disabled
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Inscrição estadual</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="dadosFicha.inscricao_estadual_destino"
                    :disabled="dadosFicha.tipo_produtor === 'F'"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group required">
                  <label>Propriedade</label>
                  <select
                    class="form-control"
                    v-model="dadosFicha.cod_propriedade"
                    @change="onChangePropriedade"
                  >
                    <option value>Selecione</option>
                    <option
                      v-for="(propriedade, index) in propriedades"
                      :key="index"
                      :value="propriedade.codpropriedade"
                    >
                      {{
                        `${propriedade.codpropriedade} - ${propriedade.nomepropriedade}`
                      }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group required">
                  <label for="endereco_origem">Endereço</label>
                  <input
                    type="text"
                    class="form-control"
                    name="endereco_origem"
                    id="endereco_origem"
                    v-model="dadosFicha.endereco_origem"
                    :readonly="selected_propriedade"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group required">
                  <label for="municipio_origem">Município</label>
                  <input
                    type="text"
                    class="form-control"
                    name="municipio_origem"
                    id="municipio_origem"
                    v-model="dadosFicha.municipio_origem"
                    :readonly="selected_propriedade"
                  />
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group required">
                  <label for="uf_origem">UF</label>
                  <input
                    type="text"
                    class="form-control"
                    name="uf_origem"
                    id="uf_origem"
                    v-model="dadosFicha.uf_origem"
                    :readonly="selected_propriedade"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="container content-1">
            <p class="text-description">
              O segundo passo são as informações sobre os Produtos. Após
              preencher as informações obrigatórias
              <span class="text text-red">(*)</span>, clique em
              <span class="text-next" @click="changeStep($event, +1)"
                >Próximo</span
              >.
            </p>

            <add-item-table-component
              v-model="dadosFicha.produtos"
              id-field="cod_gtiv_ficha_produtos"
              name="gtiv_ficha_produtor"
              :required="true"
              @change="addedProdutos($event)"
            >
              <div class="row form-fields">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="produto">Produto</label>
                    <!-- <input type="text" class="form-control" name="produto" id="produto" /> -->
                    <select
                      name="produto"
                      id="produto"
                      class="form-control"
                      v-model="selectedProduto"
                    >
                      <option value>Selecione</option>
                      <option
                        v-for="(cult, index) in culturasPermitidasPropriedade"
                        :key="index"
                        :value="cult.cd_cultura"
                      >
                        {{ cult.nm_cultura }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="d-none">
                  <div class="form-group">
                    <label for="variedade">Variedade</label>
                    <input
                      type="tel"
                      class="form-control"
                      name="variedade"
                      id="variedade"
                      v-model="variedade"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="qtd">Quantidade</label>
                    <input
                      type="numeric"
                      class="form-control"
                      name="qtd"
                      id="qtd"
                      v-numeric
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="capacidade_reservatorio">Unidade</label>
                    <select name="unidade" id="unidade" class="form-control">
                      <option value>Selecione</option>
                      <option
                        v-for="(um, index) in unidadesDeMedida"
                        :key="index"
                        :value="um.cod_unidade_medida"
                      >
                        {{ um.descricao_unidade_medida }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="num_unidade_producao"
                      >N° da unidade de produção</label
                    >
                    <select
                      name="num_unidade_producao"
                      id="num_unidade_producao"
                      class="form-control"
                      v-model="variedade_cod"
                      @change="onChangeUnidadeProducao(variedade_cod)"
                    >
                      <option value="">Selecione</option>
                      <option
                        :value="up.cd_unidade_producao"
                        v-for="(up, index) in getUnidadesProducao"
                        :key="index"
                      >
                        {{ up.cd_unidade_producao }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </add-item-table-component>
          </div>
          <div class="container content-2">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="cpf_cnpj_destinatario"
                    >CPF/CNPJ do destinatário</label
                  >
                  <input
                    type="tel"
                    class="form-control"
                    name="cpf_cnpj_destinatario"
                    id="cpf_cnpj_destinatario"
                    v-model="dadosFicha.cpf_cnpj_destinatario"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    @blur="
                      onCpfCnpjDestinoBlur(dadosFicha.cpf_cnpj_destinatario)
                    "
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group required">
                  <label for="destinatario">Nome do destinatário</label>
                  <input
                    type="text"
                    class="form-control"
                    name="destinatario"
                    id="destinatario"
                    v-model="dadosFicha.destinatario"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group required">
                  <label for="endereco_destino">Endereço</label>
                  <input
                    type="text"
                    class="form-control"
                    name="endereco_destino"
                    id="endereco_destino"
                    v-model="dadosFicha.endereco_destino"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group required">
                  <label for="municipio" style="margin-bottom: 5px"
                    >Município</label
                  >
                  <select-municipio-component
                    name="municipio"
                    v-model="dadosFicha.municipioDestinoObj"
                    :just-ceara="true"
                  ></select-municipio-component>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group required">
                  <label>UF</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="dadosFicha.municipioDestinoObj.uf"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Inscrição estadual</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="dadosFicha.inscricao_estadual_destino"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="container content-3">
            <h3>Identificação de transporte/condutor</h3>
            <div
                :class="{
                  'form-group': true,
                  'radio-group': true,
                  required: !dadosFicha.tipo_transporte
                }"
              >
              <label class="text text-primary">Tipo de transporte:</label>
              <div class="row">
                <div class="col-md-2">
                  <label>
                    <input
                      type="radio"
                      name="tipo_transporte"
                      v-model="dadosFicha.tipo_transporte"
                      value="RODOVIÁRIO"
                    />
                    Rodoviário
                  </label>
                </div>
                <div class="col-md-2">
                  <label>
                    <input
                      type="radio"
                      name="tipo_transporte"
                      v-model="dadosFicha.tipo_transporte"
                      value="AEREO"
                    />
                    Aéreo
                  </label>
                </div>
                <div class="col-md-2">
                  <label>
                    <input
                      type="radio"
                      name="tipo_transporte"
                      v-model="dadosFicha.tipo_transporte"
                      value="HIDROVIARIO"
                    />
                    Hidroviário
                  </label>
                </div>
                <div class="col-md-2">
                  <label>
                    <input
                      type="radio"
                      name="tipo_transporte"
                      v-model="dadosFicha.tipo_transporte"
                      value="FERROVIARIO"
                    />
                    Ferroviário
                  </label>
                </div>
                <div class="col-md-3">
                  <label>
                    <input
                      type="radio"
                      name="tipo_transporte"
                      v-model="dadosFicha.tipo_transporte"
                      value="OUTRO"
                    />
                    Outro
                  </label>
                  <div
                    class="form-group"
                    v-show="dadosFicha.tipo_transporte == 'OUTRO'"
                  >
                    <input
                      type="text"
                      class="form-control"
                      v-model="dadosFicha.tipo_transporte_outro"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="nome_condutor">Nome do condutor</label>
                  <input
                    type="text"
                    class="form-control"
                    name="nome_condutor"
                    id="nome_condutor"
                    v-model="dadosFicha.nome_condutor"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="num_habilitacao">N° Habilitação</label>
                  <input
                    type="text"
                    class="form-control"
                    name="num_habilitacao"
                    id="num_habilitacao"
                    v-model="dadosFicha.num_habilitacao"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="cpf_condutor">CPF</label>
                  <input
                    type="text"
                    class="form-control"
                    name="cpf_condutor"
                    id="cpf_condutor"
                    v-model="dadosFicha.cpf_condutor"
                    v-mask="'###.###.###-##'"
                    @blur="validateCpf(dadosFicha.cpf_condutor)"
                  />
                </div>
              </div>
            </div>
            <h3>Identificação do veículo</h3>
            <div class="row">
              <div class="col-md-4">
                <div
                  :class="{
                    'form-group': true,
                    required: dadosFicha.tipo_transporte == 'RODOVIÁRIO',
                  }"
                >
                  <div class="form-group">
                    <label for="marca_modelo_veiculo">Marca/Modelo</label>
                    <input
                      type="text"
                      class="form-control"
                      name="marca_modelo_veiculo"
                      id="marca_modelo_veiculo"
                      v-model="dadosFicha.marca_modelo_veiculo"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label class="show-control-text" for="is_mercosul"
                    >Placa Mercosul?</label
                  >
                  <label class="switch">
                    <input
                      type="checkbox"
                      class="form-control"
                      id="is_mercosul"
                      v-model="dadosFicha.is_mercosul"
                      @input="onChangeIs_mercosul()"
                    />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
              <div class="col-md-2">
                <div
                  :class="{
                    'form-group': true,
                    required: dadosFicha.tipo_transporte == 'RODOVIÁRIO',
                  }"
                >
                  <label for="placa_veiculo">Placa</label>
                  <input
                    type="text"
                    class="form-control"
                    name="placa_veiculo"
                    id="placa_veiculo"
                    v-mask="dadosFicha.mask"
                    v-model="dadosFicha.placa_veiculo"
                  />
                </div>
              </div>
              <div class="col-md-4" v-if="dadosFicha.is_mercosul">
                <div
                  :class="{
                    'form-group': true,
                    required: dadosFicha.tipo_transporte == 'RODOVIÁRIO',
                  }"
                >
                  <label for="nacionalidade_veiculo">País</label>
                  <select-nacionalidade-placa-component
                    name="nacionalidade_veiculo"
                    id="nacionalidade_veiculo"
                    class="autocomplete"
                    v-model="dadosFicha.nacionalidade_veiculoObj"
                    :isMercosul="true"
                  ></select-nacionalidade-placa-component>
                </div>
              </div>
              <div class="col-md-4" v-else>
                <div
                  :class="{
                    'form-group': true,
                    required: dadosFicha.tipo_transporte == 'RODOVIÁRIO',
                  }"
                >
                  <label for="municipio_veiculo">Município</label>
                  <select-municipio-component
                    id="municipio_veiculo"
                    name="municipio_veiculo"
                    v-model="dadosFicha.municipio_veiculo"
                    :just-ceara="false"
                  ></select-municipio-component>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group required">
                  <label for="itinerario">Itinerário</label>
                  <textarea
                    name="itinerario"
                    id="itinerario"
                    class="form-control"
                    v-model="dadosFicha.itinerario"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="actions">
          <a
            href="#"
            @click="changeStep($event, -1)"
            :class="{
              'steps-control': true,
              disabled:
                !allowPrev || dadosFicha.boas_praticas_agropecuarias == 'nao',
            }"
            >Anterior</a
          >
          <a
            href="#"
            @click="changeStep($event, +1)"
            :class="{
              'steps-control': true,
              disabled:
                dadosFicha.boas_praticas_agropecuarias == 'nao' ||
                serverFeedback.success,
            }"
            >{{ nextText }}</a
          >
        </div>
      </div>
    </div>

    <modal-component
      v-model="serverFeedback.show"
      title="Aviso"
      :error="!serverFeedback.success"
      :backdrop=true
      :refreshPage=true
    >
      <div class="modal-content">
        <p class="text text-center">
          {{ serverFeedback.message }}
        </p>
        <a :href="serverFeedback.link_ficha" class="btn-primary" target="_blank"
          ><span>Baixar GTIV</span></a
        >
        <br />
        <!-- <br />
        <a
          :href="serverFeedback.link_boleto"
          class="btn-primary"
          target="_blank"
          ><span>Baixar boleto</span></a
        > -->
      </div>
    </modal-component>
  </div>
</template>

<script>
export default {
  props: {
    cpfCnpjProdutor: {
      required: true,
    },
    tokenAuth: {
      required: true,
    },
    culturasPermitidas: {
      required: true,
    },
  },
  data: () => ({
    activeTab: 0,
    nextText: "Próximo",
    propriedades: [],
    selected_propriedade: false,
    variedade_cod: null,
    variedade: "",
    dadosFicha: {
      // Origem
      cod_propriedade: "",
      nome_propriedade: "",
      nome_produtor_origem: "",
      cpf_cnpj_produtor_origem: "",
      endereco_origem: "",
      municipio_origem: "",
      cod_municipio_origem: "",
      uf_origem: "",
      inscricao_estadual_origem: "",
      tipo_produtor: "",
      // Produtos
      produtos: [],
      // Destino
      destinatario: "",
      cpf_cnpj_destinatario: "",
      endereco_destino: "",
      municipio_destino: "",
      cod_municipio_destino: "",
      uf_destino: "",
      inscricao_estadual_destino: "",
      municipioDestinoObj: {
        label: "",
        value: "",
        uf: "",
      },
      // Transporte/condutor
      tipo_transporte: "",
      tipo_transporte_outro: "",
      nome_condutor: "",
      num_habilitacao: "",
      cpf_condutor: "",
      marca_modelo_veiculo: "",
      mask: "AAA-####",
      is_mercosul: false,
      placa_veiculo: "",
      municipio_veiculo: "",
      nacionalidade_veiculo: "",
      itinerario: "",
    },
    selectedProduto: "",
    culturasPermitidasPropriedade: [],
    unidadesDeMedida: [],
    unidadesProducao: [],
    serverFeedback: {
      show: false,
      message: null,
      code: null,
      link_boleto: "#",
      link_ficha: "#",
      success: false,
    },
  }),
  computed: {
    getUnidadesProducao() {
      return this.unidadesProducao.filter(
        (up) =>up.cd_cultura.toString() == this.selectedProduto.toString()
      );
    },
    allowPrev() {
      return this.activeTab > 0;
    },
  },
  methods: {
    validateCpf(cpf) {
      if (!cpf) {
        return;
      }
      const _cpf = cpf.replace(/[^0-9]/g, "");

      if (_cpf.length !== 11) {
        this.$toast.error("CPF inválido.");
        return;
      }

      if (!window.cpfValidation(_cpf)) {
        this.$toast.error("CPF inválido.");
        return;
      }
    },
    onCpfCnpjDestinoBlur(cpfCnpj) {
      const _cpfCnpj = cpfCnpj && cpfCnpj.replace(/[^0-9]/g, "");

      if (!_cpfCnpj || _cpfCnpj == "") {
        return;
      }

      if (
        (_cpfCnpj.length !== 11 && _cpfCnpj.length !== 14) ||
        (_cpfCnpj.length === 11 && !window.cpfValidation(_cpfCnpj)) ||
        (_cpfCnpj.length === 14 && !window.cnpjValidation(_cpfCnpj))
      ) {
        // ficha.cpf_cnpj_destinatario = "";
        this.$toast.error("CPF/CNPJ inválido.");
        return;
      }

      window.showPageLoading();

      window.api
        .fetch(`/api/get-pessoa-data`, {
          params: {
            cpf_cnpj: _cpfCnpj,
          },
        })
        .then((response) => {
          const pessoa = response.data;

          if (pessoa.nome || pessoa.razao_social) {
            this.dadosFicha.destinatario = pessoa.nome || pessoa.razao_social;
          }

          if (pessoa.logradouro) {
            this.dadosFicha.endereco_destino =
              pessoa.logradouro +
              (pessoa.logradouro_numero ? ", " + pessoa.logradouro_numero : "");
          }

          if (pessoa.inscricao_estadual) {
            this.dadosFicha.inscricao_estadual_destino =
              pessoa.inscricao_estadual;
          }

          if (pessoa.municipio) {
            this.dadosFicha.municipioDestinoObj = {
              label: null,
              value: pessoa.municipio,
              uf: null,
            };
          }

          window.hidePageLoading();
        })
        .catch((error) => {
          window.hidePageLoading();
        });
    },
    onChangeUnidadeProducao(val) {
      let name = this.unidadesProducao.find(
        (el) => el.cd_unidade_producao == val
      );
      if (val != "" && typeof name !== "undefined") {
        this.variedade = name.nm_variedade;
      }
    },
    onChangePropriedade(ev) {
      const value = ev.target.value;
      const Strings = {};
      Strings.orEmpty = function (entity) {
        return entity || "";
      };
      if (value) {
        this.dadosFicha.nome_propriedade =
          ev.target.options[ev.target.selectedIndex].innerText;
        // Setar selected_propriedade
        this.selected_propriedade = true;
        let tempEndereco = this.propriedades[ev.target.selectedIndex - 1].aux;
        this.dadosFicha = {
          ...this.dadosFicha,
          endereco_origem:
            Strings.orEmpty(tempEndereco.nm_logradouro) +
            ", " +
            Strings.orEmpty(tempEndereco.nr_endereco) +
            " - " +
            Strings.orEmpty(tempEndereco.nm_bairro),
          municipio_origem: tempEndereco.ds_municipio,
          cod_municipio_origem: tempEndereco.cd_municipio,
          uf_origem: tempEndereco.cd_estado,
        };
      } else {
        this.selected_propriedade = false;
        this.dadosFicha.nome_propriedade = "";
        this.dadosFicha.endereco_origem = "";
        this.dadosFicha.municipio_origem = "";
        this.dadosFicha.uf_origem = "";
      }

      this.loadUnidadesProducao();
    },
    loadPropriedades() {
      window.showPageLoading();

      window.api
        .fetch(`/sidagro-api/get-produtor-and-propriedades`, {
          params: {
            cpf_cnpj: this.cpfCnpjProdutor,
          },
          headers: {
            Authorization: `Basic ${this.tokenAuth}`,
          },
        })
        .then((response) => {
          window.hidePageLoading();

          const produtor = response.data;
          this.is_produtor_sidagro = true;

          this.dadosFicha = {
            ...this.dadosFicha,
            nome_produtor_origem: produtor.nomeprodutor,
            tipo_produtor: produtor.tipoprodutor,
          };
          this.propriedades = produtor.propriedades || [];
        })
        .catch((error) => {
          this.dadosFicha.cpf_cnpj_produtor_origem = "";
          window.hidePageLoading();
        });
    },
    changeActive() {
      document.querySelectorAll(`.tabs .tab`).forEach((node) => {
        node.classList.remove("active");
      });
      document.querySelectorAll(`.content .container`).forEach((node) => {
        node.classList.remove("active");
      });
      document
        .querySelector(`.tabs .tab.tab-${this.activeTab}`)
        .classList.add("active");
      document
        .querySelector(`.content .container.content-${this.activeTab}`)
        .classList.add("active");

      const stepsDiv = this.$el.querySelector(".steps");
      stepsDiv.scrollIntoView();
    },
    changeStep(ev, op) {
      ev.preventDefault();
      ev.stopPropagation();
      const tabsCount = this.$el.querySelectorAll(".tabs .tab").length;
      if (op < 0 && this.activeTab == 0) return;
      else if (op < 0) {
        this.activeTab += op;
        this.changeActive();
        this.nextText = "Próximo";
        return;
      }

      let focusSeted = false;
      const activeTab = this.$el.querySelector(".container.active");

      const isValid = window.validateForm(activeTab);

      if (isValid && op > 0 && this.activeTab == tabsCount - 1) {
        // Salvando
        this.onSave();
      } else if (isValid) {
        this.activeTab += op;
        this.changeActive();
        if (this.activeTab === tabsCount - 1) {
          this.nextText = "Salvar";
        } else {
          this.nextText = "Próximo";
        }
      }
    },
    addedProdutos(ev) {
      this.dadosFicha.produtos = ev;
    },
    onChangeIs_mercosul() {
      this.dadosFicha.placa_veiculo = "";
      this.dadosFicha.municipio_veiculo = "";
      this.dadosFicha.nacionalidade_veiculo = "";
      if (this.dadosFicha.is_mercosul) {
        this.dadosFicha.mask = "AAA-####";
      } else {
        this.dadosFicha.mask = "AAA#A##";
      }
    },
    onSave() {
      const formData = new FormData();

      this.dadosFicha.municipio_destino = this.dadosFicha.municipioDestinoObj.label;
      this.dadosFicha.cod_municipio_destino = this.dadosFicha.municipioDestinoObj.value;
      this.dadosFicha.uf_destino = this.dadosFicha.municipioDestinoObj.uf;

      formData.set("data", JSON.stringify(this.dadosFicha));

      window.showPageLoading();
      window.api
        .fetch("/gtiv/gtiv-individual/salvar", {
          method: "post",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Basic ${this.tokenAuth}`,
          },
        })
        .then((response) => {
          window.hidePageLoading();
          this.serverFeedback = {
            show: true,
            message: response.message,
            code: response.code,
            link_boleto: response.data.link_boleto,
            link_ficha: response.data.link_ficha,
            success: true,
          };
        })
        .catch((error) => {
          window.hidePageLoading();
        });
    },
    loadUnidadesProducao() {
      window.showPageLoading();

      const cpfCnpjProdutor = this.dadosFicha.cpf_cnpj_produtor_origem;
      const codPropriedade = this.dadosFicha.cod_propriedade;
      if (!codPropriedade || !cpfCnpjProdutor) {
        this.unidadesProducao = [];
        return;
      }

      this.culturasPermitidasPropriedade = [];

      window.api
        .fetch(`/sidagro-api/get-unidades-producao`, {
          params: {
            cod_propriedade: codPropriedade,
            cpf_cnpj_produtor: cpfCnpjProdutor.replace(/[^\d]+/g, ""),
          },
        })
        .then((response) => {
          const unidadesProducao = response.data;
          if (unidadesProducao == null) {
            this.$toast.info(
              "Não foram encontradas unidades de produção para essa propriedade"
            );
            return;
          }
          this.unidadesProducao = unidadesProducao;
          const culturasPermitidasPropriedade = [];


          // unidadesProducao.forEach((up) => {
          //   const allowed = this.culturasPermitidas.some(
          //     (cultPerm) => cultPerm.nome_popular_cultura == up.nm_cultura
          //   );
          //   if (allowed) {
          //     culturasPermitidasPropriedade.push({ cd_cultura: up.cd_cultura , nm_cultura: up.nm_cultura});
          //   }
          // });

          unidadesProducao.forEach((up) => {
            
            let obj = {
              cd_cultura: up.cd_cultura,
              nm_cultura: up.nm_cultura,
            };

            let achei = false;

            culturasPermitidasPropriedade.forEach((aux, index) => {
              if (aux.cd_cultura.toString() == up.cd_cultura.toString()) {
                achei = true;
              }
            });

            if (!achei) {
              culturasPermitidasPropriedade.push(obj);
            }

          });

          if (culturasPermitidasPropriedade.length > 0) {
            this.culturasPermitidasPropriedade = [
              ...new Set(culturasPermitidasPropriedade),
            ];
            console.log(this.culturasPermitidasPropriedade);
          } else {
            this.$toast.info(
              "Nenhuma cultura permitida para essa propriedade."
            );
          }
          window.hidePageLoading();
          // this.unidadesProducao = response.data;
        })
        .catch((error) => {
          window.hidePageLoading();
          this.$toast.error("Erro ao carregar as unidades de produção");
        });
    },
    loadUnidadesMedida() {
      window.api.fetch("/public-api/get-unidades-medida-gtiv").then((response) => {
        this.unidadesDeMedida = response.data;
      });
    },
  },
  mounted() {
    this.dadosFicha.cpf_cnpj_produtor_origem = this.cpfCnpjProdutor;
    this.changeActive();
    this.loadPropriedades();
    this.loadUnidadesMedida();
  },
};
</script>
<style lang="scss" scoped>
/deep/ .sida-modal {
  max-width: 450px;
  .modal-content {
    height: auto;
  }

  .modal-footer {
    text-align: right;
  }
}

.d-none {
  display: none !important;
}
</style>
